const CONEKTA = 'conekta',
  CONEKTA_GLOBAL = 'conekta global',
  CONTPAQI = 'contpaqi',
  OXXO = 'oxxo',
  SAT = 'sat',
  SAT_DOWNLOADS = 'sat_downloads',
  SPEI = 'spei',
  STRIPE = 'stripe',
  FISERV = 'fiserv',
  TRANSFER = 'transfer',
  CARD = 'card',
  KUSHKI = 'card',
  FEMSA = 'femsa',
  MINIMUM_SPEI_TO_PAY = 10,
  MINIMUM_AMOUNT_TO_PAY = 15,
  MAXIMUN_AMOUNT_TO_PAY_OXXO = 10000,
  MINIMUM_AMOUNT_TO_PAY_CONEKTA_GLOBAL = 20,
  INTEGRATION_IS_ACTIVE = 'active',
  INTEGRATION_IS_INACTIVE = 'inactive',
  INTEGRATION_IS_ENABLE = 1,
  PAYMENT_INSTRUCTIONS_ID = 2,
  CONEKTA_INTEGRATION_ID = 5,
  OXXO_INTEGRATION_ID = 6;

export {
  CONEKTA,
  CONEKTA_GLOBAL,
  CONTPAQI,
  OXXO,
  SAT,
  SAT_DOWNLOADS,
  SPEI,
  STRIPE,
  FISERV,
  TRANSFER,
  CARD,
  KUSHKI,
  FEMSA,
  MINIMUM_AMOUNT_TO_PAY,
  MAXIMUN_AMOUNT_TO_PAY_OXXO,
  MINIMUM_AMOUNT_TO_PAY_CONEKTA_GLOBAL,
  INTEGRATION_IS_ACTIVE,
  INTEGRATION_IS_INACTIVE,
  INTEGRATION_IS_ENABLE,
  CONEKTA_INTEGRATION_ID,
  OXXO_INTEGRATION_ID,
  PAYMENT_INSTRUCTIONS_ID,
  MINIMUM_SPEI_TO_PAY
};

export const paymentTypes = {
  oxxo: 'oxxo',
  stp: 'spei',
  stripe: 'stripe',
  fiserv: 'fiserv'
};

export const integrationSpei = {
  onboarding: {
    pending: 'ONBOARDING_PENDING',
    initiated: 'ONBOARDING_INITIATED',
    completed: 'ONBOARDING_COMPLETED'
  },
  status: {
    approved: 'APPROVED',
    rejected: 'REJECTED',
    review: 'UNDER_REVIEW',
    pending: 'PENDING'
  }
};

export const SPEI_OPTIONS = {
  arcus: 'BANK_TRANSFERS_SPEI',
  kushki: 'CARDS_KUSHKI',
  fintoc: 'BANK_TRANSFERS_SPEI'
}

export const SPEI_PARTNERS = {
  ARCUS: 'arcus',
  FINTOC: 'fintoc'
}

export const SPEI_PARTNER_LABELS = {
  arcus: 'Arcus',
  fintoc: 'FINTOC'
}


// WEBPACK FOOTER //
// ./src/constants/integrations.js